// extracted by mini-css-extract-plugin
module.exports = {"date":"_aa5c384","section":"_2e5fc00","row":"_9ca629b","cell":"_162bf97","label":"_0dfda25"};